import React, { Component } from "react";
import { observer } from "mobx-react";
import CoursesStore from "../../../../stores/CoursesStore";
import CoursesReactions from "../../../../stores/CoursesStore/CoursesReactions";
import CoursesWrapper from "./CoursesWrapper";

interface Props {
  kind?: string;
  headerTitle?: string;
  userIsInUk: boolean;
}

class Courses extends Component<Props, {}> {
  coursesStore = new CoursesStore();
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.coursesStore.loading();
  }

  renderCourses = (state) => {
    const { userIsInUk, headerTitle } = this.props;

    switch (state.kind) {
      case "ready":
      case "sorting":
        return (
          <CoursesWrapper
            store={this.coursesStore}
            userIsInUk={userIsInUk}
            headerTitle={headerTitle}
          />
        );
      case "loading":
        return (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        );
      default:
        return <div />;
    }
  };

  render() {
    const { state } = this.coursesStore;

    return (
      <div className="ui segment courses">
        {this.renderCourses(state)}
        <CoursesReactions store={this.coursesStore} kind={this.props.kind} />
      </div>
    );
  }
}

export default observer(Courses);
